// Shared framer-motion variants and easings for a cohesive motion language.

export const EASE = [0.83, 0, 0.17, 1];
export const EASE_OUT = [0.16, 1, 0.3, 1];

export const revealUp = {
  hidden: { opacity: 0, y: 40 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: EASE_OUT, delay: i * 0.08 },
  }),
};

export const fadeIn = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 1, ease: EASE_OUT } },
};

// Masked line reveal — inner span slides up from 100%.
export const lineWrap = {
  hidden: {},
  show: (delay = 0) => ({
    transition: { staggerChildren: 0.09, delayChildren: delay },
  }),
};

export const lineInner = {
  hidden: { y: '110%' },
  show: {
    y: '0%',
    transition: { duration: 1.0, ease: EASE },
  },
};
